// extracted by mini-css-extract-plugin
export default {"transparencyDataTable":"transparency-module__transparencyDataTable--h1VyW"};